import { Button, Card, Grid, TextInput } from '@mantine/core';
import { useNavigate } from 'react-router';

const SettingsTabAiHubTokens = ({ domain, handleChange }) => {
  const navigate = useNavigate();

  const backButton = (
    <Button onClick={() => navigate(-1)}>
      Back to AI Hub
    </Button>
  );

  return (
    <Card withBorder>
      <Card.Section p="md">
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>OpenAI Token</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <TextInput
              name="openAIToken"
              autoComplete="nope"
              value={domain.openAIToken || ''}
              onChange={handleChange}
            />
          </Grid.Col>
        </Grid>
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Anthropic Token</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <TextInput
              name="anthropicToken"
              autoComplete="nope"
              value={domain.anthropicToken || ''}
              onChange={handleChange}
            />
          </Grid.Col>
        </Grid>
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 4 }}></Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>{backButton}</Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default SettingsTabAiHubTokens;
